/**
 * Extracts the last part of the pathname and trims it.
 * This is used as the redirect key from the current URL path.
 */
export const extractKeyFromPath = (pathname) => {
  const key = pathname.split('/').pop()?.trim();
  return key || undefined;
};

/**
 * Merges query parameters from the current location into the destination URL.
 * If both source and destination contain parameters with the same key, source takes precedence.
 */
export const mergeParams = (sourceQuery, destination) => {
  const source = new URLSearchParams(sourceQuery);
  const dest = new URLSearchParams(destination.split('?')[1]?.split('#')[0] || '');

  source.forEach((value, key) => dest.set(key, value));
  return dest.toString();
};

/**
 * Constructs the final redirect URL:
 * - Merges source query params into destination's query
 * - Preserves or prioritizes the source fragment (if present)
 * - Handles URLs with or without existing query parameters or fragments
*/
export const buildFinalRedirectUrl = (destination, sourceQuery, sourceHash) => {
  const base = destination.split('?')[0].split('#')[0];
  const query = mergeParams(sourceQuery, destination);

  // Use source fragment if present, otherwise fallback to destination fragment
  const fragment = sourceHash || (destination.includes('#') ? `#${destination.split('#')[1]}` : '');

  return `${base}${query ? `?${query}` : ''}${fragment}`;
};

/**
 * Checks whether the given URL string already includes a protocol (http or https).
 */
export const hasProtocol = (url) => /^https?:\/\//i.test(url);